type NullableInput = HTMLInputElement | null;

interface PriceCalculatorElements {
    original: HTMLInputElement;
    price: HTMLInputElement;
    discount: HTMLInputElement;
}

export class PriceCalculator {
    private wrapper: HTMLElement;
    private originalInput: HTMLInputElement;
    private priceInput: HTMLInputElement;
    private discountInput: HTMLInputElement;

    constructor(wrapper: HTMLElement) {
        this.wrapper = wrapper;

        const original = wrapper.querySelector<HTMLInputElement>('.original-price');
        const price    = wrapper.querySelector<HTMLInputElement>('.final-price');
        const discount = wrapper.querySelector<HTMLInputElement>('.discount');

        if (!original || !price || !discount) {
            throw new Error('PriceCalculator: Missing required inputs in wrapper');
        }

        this.originalInput = original;
        this.priceInput = price;
        this.discountInput = discount;

        this.bindEvents();
    }

    private bindEvents(): void {
        this.originalInput.addEventListener('input', () => this.updatePrice());
        this.discountInput.addEventListener('input', () => this.updatePrice());
        this.priceInput.addEventListener('input', () => this.updateDiscount());
    }

    private get original(): number {
        return parseFloat(this.originalInput.value) || 0;
    }

    private get price(): number {
        return parseFloat(this.priceInput.value) || 0;
    }

    private get discount(): number {
        return parseFloat(this.discountInput.value) || 0;
    }

    private updatePrice(): void {
        this.clearError();

        if (this.original <= 0) return;

        const newPrice = this.original * (1 - this.discount / 100);

        if (newPrice < 0) {
            this.setError();
            return;
        }

        this.priceInput.value = newPrice.toFixed(2);
    }

    private updateDiscount(): void {
        this.clearError();

        if (this.original <= 0) return;

        if (this.price > this.original) {
            this.setError();
            return;
        }

        const discount = (1 - this.price / this.original) * 100;
        this.discountInput.value = discount.toFixed(2);
    }

    private setError(): void {
        this.wrapper.classList.add('has-error');
        this.discountInput.value = '';
    }

    private clearError(): void {
        this.wrapper.classList.remove('has-error');
    }
}